/**
 * GeChiUI dependencies
 */
import { createHigherOrderComponent, useDebounce } from '@gechiui/compose';
import { speak } from '@gechiui/a11y';

/**
 * A Higher Order Component used to be provide speak and debounced speak
 * functions.
 *
 * @see https://developer.gechiui.com/block-editor/packages/packages-a11y/#speak
 *
 * @param {GCComponent} Component The component to be wrapped.
 *
 * @return {GCComponent} The wrapped component.
 */
export default createHigherOrderComponent(
	( Component ) => ( props ) => (
		<Component
			{ ...props }
			speak={ speak }
			debouncedSpeak={ useDebounce( speak, 500 ) }
		/>
	),
	'withSpokenMessages'
);
